import { ResponseWrapper, ErrorWrapper } from './utils';
import getEnv from '@/utils/env';

const API_URL =
  getEnv('VUE_APP_CUSTOM_HOST') ||
  process.env.VUE_APP_CUSTOM_HOST ||
  'http://localhost:8889/api/v2';
let BEARER = '';

import axiosInstance from '@/services/api/http.service';

// This is a interface which extendds
export class CustomService {
  static get entity() {
    return 'custom';
  }

  /**
   ******************************
   * @API
   ******************************
   */
  static async getDashboardTemplate(id, widgetsRequired = true) {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `${API_URL}/dashboard/${id}/widget?widgetsRequired=${widgetsRequired}`,
      );
      // const response = await axiosInstance({ auth: true }).get(API_URL+`/dashboard/` + id);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async postDashboardTemplate({ id, widget }) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/dashboard/${id}/widget`,
        widget,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async deleteDashboardWidget({ dashId, widgetId }) {
    try {
      const response = await new axiosInstance({ auth: true }).delete(
        `${API_URL}/dashboard/${dashId}/widget/${widgetId}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async reorderDashboardWidget({ dashId, widgetOrder }) {
    try {
      const response = await new axiosInstance({ auth: true }).put(
        `${API_URL}/dashboard/${dashId}/reorder`,
        {
          widgetOrder,
        },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getAllDashboards({ page, size, searchKeyword }) {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `${API_URL}/dashboard/meta/?page=${page}&size=${size}&searchKeyword=${encodeURIComponent(searchKeyword)}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async deleteDashboard(id) {
    try {
      const response = await new axiosInstance({ auth: true }).delete(
        `${API_URL}/dashboard/${id}`,
        {
          id,
        },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async addDashboard({ name, templateName, serviceIds }) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/dashboard/`,
        {
          name,
          templateName,
          serviceIds,
        },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async addDashboardFromId({ name, id }) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/dashboard?copyFrom=${id}`,
        {
          name,
        },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async editDashboard({ name, id }) {
    try {
      const response = await new axiosInstance({ auth: true }).put(
        `${API_URL}/dashboard/${id}`,
        {
          name,
        },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async reMapIndex(metricData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/dashboard/remap`,
        metricData,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
